import {createRoot} from 'react-dom/client'
import 'antd/dist/antd.less'
import {BrowserRouter as Router} from 'react-router-dom'
import {QueryClientProvider} from 'react-query'
import {ReactQueryDevtools} from 'react-query/devtools'

import 'styles/index.scss'
import {App, ScrollToTop, queryClient} from 'base'

createRoot(document.getElementById('root')!).render(
  <QueryClientProvider client={queryClient}>
    <Router>
      <ScrollToTop />
      <App />
    </Router>
    <ReactQueryDevtools position="bottom-right" />
  </QueryClientProvider>
)
